// extracted by mini-css-extract-plugin
export default {"filterWrapper":"WorkstationInfo_filterWrapper__KreJf","spaceStyle":"WorkstationInfo_spaceStyle__yOJ1v"};